import {merge} from 'lodash';
import { generateFormPayload } from './forms';

// Wrap fetch method since jquery ajax requests are proper promises so aren't chainable
// All requests include cookies by default here

function _fetch(url, method, config) {
  let init = { credentials: 'include', method }; // no credentials: include for requests from wordpress

  merge(init, config || {});

  return fetch(new Request(url), init);
}

/**
 * Performs a GET request
 * @param {string}  url     The url to perform the request from.
 * @param {object}  config  An optional config object to override the fetch settings
 * @returns {Promise}       The result of the get request
 */
export function get(url, config = {}) {
  return _fetch(url, 'GET', config);
}

/**
 * Performs a POST request
 * @param {string}  url     The url of the request
 * @param {object}  body    The body of the post request; if an object sends as json, otherwise sends directly.
 * @param {object}  config  An optional config object to override the fetch settings
 * @param {bool} shouldFormEncode Encode the data like a native form POST (application/x-www-form-url-encoded)?
 * @param {bool} shouldFormMultipartEncode Encode the data like a native form POST with files? (multipart/form-data)?
 * @returns {Promise}       The result of the post request
 */
export function post(url, body = null, config = {}, shouldFormEncode = false, shouldFormMultipartEncode = false) {
  const bodyConfig = !body
    ? {}
    : typeof body === 'object'
      ? {
        headers: {
          'Content-Type': shouldFormEncode ? 'application/x-www-form-urlencoded' : 'application/json',
        },
        body: shouldFormEncode ? generateFormPayload(body) : JSON.stringify(body),
      }
      : { body };

  merge(bodyConfig, config || {});

  if (shouldFormMultipartEncode && bodyConfig['headers'] && bodyConfig['headers']['Content-Type']) {
    delete bodyConfig['headers']['Content-Type'];
  }

  return _fetch(url, 'POST', bodyConfig);
}
/**
 * Performs a POST request
 * @param {string}  url     The url of the request
 * @param {object}  body    The body of the post request; if an object sends as json, otherwise sends directly.
 * @param {object}  config  An optional config object to override the fetch settings
 * @returns {Promise}       The result of the post request
 */
export function put(url, body = null, config = {}) {
  const bodyConfig = !body
    ? {}
    : typeof body === 'object'
      ? {
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
      : { body };

  merge(bodyConfig, config || {});

  return _fetch(url, 'PUT', bodyConfig);
}

/**
 * Performs a POST request
 * @param {string}  url     The url of the request
 * @param {object}  body    The body of the post request; if an object sends as json, otherwise sends directly.
 * @param {object}  config  An optional config object to override the fetch settings
 * @returns {Promise}       The result of the post request
 */
export function deleteRequest(url, body = null, config = {}) {
  const bodyConfig = !body
    ? {}
    : typeof body === 'object'
      ? {
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
      : { body };

  return _fetch(url, 'DELETE', Object.assign(bodyConfig, config || {}));
}
